<template>
  <BaseSelect v-model="currentlySelectedOption" :options="selectBooleanColumnOperators" :append-to-body="true"></BaseSelect>
  <BaseSelect
    v-if="booleanFilter.option === BooleanColumnOperators.BOOLEAN"
    v-model="booleanInput"
    :options="selectBooleanOptions"
    :append-to-body="true"
  >
  </BaseSelect>
  <ValueExistsFilter
    v-if="booleanFilter.option === CommonColumnOperators.VALUE_EXISTS"
    v-model="booleanFilter"
  ></ValueExistsFilter>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BaseSelect from "../../../../components/BaseSelect.vue";
import { BooleanColumnOperators, CommonColumnOperators } from "../../enum.filterOperators";
import { EMPTY_VALUE_PLACEHOLDER } from "../../service.genericTable";
import { BooleanFilterType } from "../../type.genericTableQuery";
import ValueExistsFilter from "./ValueExistsFilter.vue";
const { t } = useI18n();
const booleanFilterType = defineModel<BooleanFilterType>({ required: true });
const booleanFilter = computed(() => booleanFilterType.value.filter);

const currentlySelectedOption = computed({
  get() {
    return booleanFilter.value.option;
  },
  set(newOption) {
    if (newOption !== booleanFilter.value.option) {
      booleanFilter.value.value = undefined;
      booleanFilter.value.option = newOption;
    }
  },
});

const selectBooleanOptions = [
  { value: EMPTY_VALUE_PLACEHOLDER, label: t("genericTable.booleanFilter.all") },
  { value: true, label: t("genericTable.booleanFilter.true") },
  { value: false, label: t("genericTable.booleanFilter.false") },
];

const selectBooleanColumnOperators = [
  { value: BooleanColumnOperators.BOOLEAN, label: t("genericTable.booleanFilter.trueFalse") },
  { value: CommonColumnOperators.VALUE_EXISTS, label: t("genericTable.valueExistsFilter.valueExists") },
];

const booleanInput = computed<boolean | typeof EMPTY_VALUE_PLACEHOLDER>({
  get: () => (booleanFilter.value.value === undefined ? EMPTY_VALUE_PLACEHOLDER : booleanFilter.value.value),
  set: (val) => {
    booleanFilter.value.value = val === EMPTY_VALUE_PLACEHOLDER ? undefined : val;
  },
});
</script>
